import { LockSimple, LockSimpleOpen, Check } from '@phosphor-icons/react';
import type { SongAccess } from '../utils/drumHelpers';

interface AccessLockIconProps {
  type: SongAccess['type'];
}

function AccessLockIcon({ type }: AccessLockIconProps) {
  if (type === 'locked') return <span className="access-lock-icon access-lock-icon--locked"><LockSimple weight="fill" /></span>;
  if (type === 'partial') return <span className="access-lock-icon access-lock-icon--partial"><LockSimpleOpen weight="duotone" /><i /></span>;
  return <span className="access-lock-icon access-lock-icon--open"><LockSimpleOpen weight="fill" /><Check weight="bold" /></span>;
}

export default AccessLockIcon;
